import { render, staticRenderFns } from "./super-member.vue?vue&type=template&id=bbcb4698&scoped=true&"
import script from "./super-member.vue?vue&type=script&lang=ts&"
export * from "./super-member.vue?vue&type=script&lang=ts&"
import style0 from "./super-member.vue?vue&type=style&index=0&id=bbcb4698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcb4698",
  null
  
)

export default component.exports